// extracted by mini-css-extract-plugin
export var header = "_fb-0";